"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.of = undefined;

var _ArrayObservable = require("./ArrayObservable");

var of = exports.of = _ArrayObservable.ArrayObservable.of;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/observable/of.js
// module id = 159
// module chunks = 177